"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readlatestcyclecount = exports.updateinventoryquantityandlot = exports.savecyclecount = exports.savecyclecountinitial = exports.removeFile = exports.uploadFile = exports.submit = exports.parserow = exports.parse = exports.remove = exports.saveproviders = exports.savepatients = exports.saveinventorysite = exports.saveinventories = exports.savecontact = exports.deletecontact = exports.createusersiteupdaterequest = exports.save = exports.readforapproveremail = exports.read = exports.enrolltoerx = exports.listProviders = exports.listProvidersLite = exports.listeditproviders = exports.listDistributors = exports.listpatients = exports.listPatientsLite = exports.listeditpatients = exports.listpads = exports.listorders = exports.listcontacts = exports.listusers = exports.listinventories = exports.listSitesManual = exports.listSitesBillingBalance = exports.listdeletedsites = exports.listsitesnorelation = exports.listsallitesnorelation = exports.loadSpecificSites = exports.list = exports.listcyclecounts = exports.create = exports.savesitedistributors = exports.listsitedistributors = exports.deleteCopay = exports.saveCopay = exports.readCopays = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.readCopays = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/read-copays",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.saveCopay = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/save-copay",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.deleteCopay = endpoint_1.createEndpoint()({
    method: "delete",
    path: "site/delete-copay",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.listsitedistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listsitedistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.savesitedistributors = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/savesitedistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.create = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/create",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_CREATE
});
exports.listcyclecounts = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listcyclecounts",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.list = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/list",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.loadSpecificSites = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/load-specific-sites",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
// C-117_UAT
exports.listsallitesnorelation = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listsallitesnorelation",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.listsitesnorelation = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listsitesnorelation",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.listdeletedsites = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listdeletedsites",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.listSitesBillingBalance = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listSitesBillingBalance",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.listSitesManual = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listsitesmanual",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});
exports.listinventories = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listinventories",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_READ
    // query: { id: number; start: number; count: number; search?: string };
});
exports.listusers = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listusers",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_READ
});
exports.listcontacts = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listcontacts",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_READ
});
exports.listorders = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listorders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
    // query: { id: number; start: number; count: number }
});
exports.listpads = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listpads",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_READ
    // query: {
    //   count?: number;
    //   id: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   sort?: string;
    //   start?: number;
    // };
});
exports.listeditpatients = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listeditpatients",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
    // query: {
    //   count?: number;
    //   id: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   sort?: string;
    //   start?: number;
    // };
});
exports.listPatientsLite = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/listpatientslite",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
});
exports.listpatients = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listpatients",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
});
exports.listDistributors = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listDistributors",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
    // query: {
    //   count?: number;
    //   id: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   sort?: string;
    //   start?: number;
    // };
});
exports.listeditproviders = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listeditproviders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ
    // query: {
    //   count?: number;
    //   id: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   sort?: string;
    //   start?: number;
    // };
});
exports.listProvidersLite = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/listproviderslite",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ
});
exports.listProviders = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/listproviders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_READ
    // query: {
    //   count?: number;
    //   id: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   sort?: string;
    //   start?: number;
    // };
});
exports.enrolltoerx = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/enrolltoerx",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
// E-025
exports.read = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/read",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ,
    tokens: { id: "number.required" }
});
exports.readforapproveremail = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/readforapproveremail",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ,
    tokens: { id: "number.required" }
});
exports.save = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/save",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_UPDATE
});
exports.createusersiteupdaterequest = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "site/createusersiteupdaterequest",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_UPDATE
});
exports.deletecontact = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/deletecontact",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_UPDATE
});
exports.savecontact = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/savecontact",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_UPDATE
});
exports.saveinventories = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/saveinventories",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE
});
exports.saveinventorysite = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/saveinventorysite",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE
});
exports.savepatients = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/savepatients",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_UPDATE
});
exports.saveproviders = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/saveproviders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PROVIDER_UPDATE
});
exports.remove = endpoint_1.createEndpoint()({
    method: "delete",
    path: "site/remove",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_DELETE,
    tokens: { id: "numer.required" }
});
exports.parse = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "site/parse",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_CREATE
});
exports.parserow = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "site/parserow",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_CREATE
});
exports.submit = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/submit",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_CREATE
});
exports.uploadFile = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "site/uploadFile",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_CREATE
});
exports.removeFile = endpoint_1.createEndpoint()({
    method: "post",
    path: "site/removeFile",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_DELETE,
    tokens: { id: "number.required" }
});
exports.savecyclecountinitial = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/savecyclecountinitial",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.savecyclecount = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/savecyclecount",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateinventoryquantityandlot = endpoint_1.createEndpoint()({
    method: "put",
    path: "site/updateinventoryquantityandlot",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.readlatestcyclecount = endpoint_1.createEndpoint()({
    method: "get",
    path: "site/readlatestcyclecount",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_SITE_READ
});



//////////////////
// WEBPACK FOOTER
// ./src/api/site/site-client.ts
// module id = 1000
// module chunks = 0 1 2